module.exports = __webpack_public_path__ + "static/img/Bachelor_010239.29260b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010239.jpg
// module id = 125
// module chunks = 0